module.exports = __webpack_public_path__ + "static/media/tokenum.5d4a0525.svg";